import React from 'react';
import SuperAdminLayout from 'SuperAdmin/SuperAdminLayout/SuperAdminLayout';

import SettingsNav from 'SuperAdmin/SuperAdminNav/SettingsNav';

const SoftwareSettings =() =>{
    return<>
    
    <SuperAdminLayout>

        <SettingsNav />


    </SuperAdminLayout>

    </>
}



export default SoftwareSettings